import { Component, ElementRef, Inject, Input, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA, MatDialogConfig,
} from '@angular/material/dialog';

export interface DialogData {
  title?: string;
  question: string;
  yes: string;
  no: string;
  align?: string;
  backgroundColor?: string;
  icon?: string;
  trigger?: ElementRef;
}

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
  @Input() filename!: string;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    if (this.data.trigger) {
      const matDialogConfig: MatDialogConfig = new MatDialogConfig();
      const rect = this.data.trigger.nativeElement.getBoundingClientRect();
      matDialogConfig.position = { top: `${rect.top}px` };
      this.dialogRef.updatePosition(matDialogConfig.position);
    }
  }

  onYesClick(): void {
    this.dialogRef.close();
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
